<ng-template pu-mat-dialog-title>
  {{ data.title | translate }}【{{ data.header | translate }}】
</ng-template>

<gov-table class="position-absolute w-100 h-100 px-2" [datasets]="currentmodule" (onCommandTemplate)="
        $event.config.data.title = 'supervise.records';
        $event.config.disableClose = false;
        $event.template = component
      "></gov-table>